import countriesData from 'data/countries.json';

export const sortedCountries = countriesData.countries.sort((a, b) => {
  if (a.value === 'USA') return -1;
  if (b.value === 'USA') return 1;
  return a.label.localeCompare(b.label);
});
